angular.module('Services')
    .factory('Shipments', function (
        $http,
        $rootScope,
        $filter,
        Error,
        Request,
        $q,
        DownloadReportsSocketService
    ) {
        return {
            cancel: function (id, callback, errCallback) {
                Request.post({
                    url: ApiURLs.shipment.cancel.replace(':id', id),
                    method: 'PATCH',
                    successCallback: callback,
                    errorCallback: errCallback
                }, data);
            },
            updateTrackingStatus: function (id, data, callback, errCallback) {
                Request.post({
                    url: ApiURLs.shipment.updateTrackingStatus.replace(':id', id),
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errCallback,
                }, data);
            },

            updateMilesTrackingStatus: function (id, data, callback, errCallback) {
                const paramsUrl = `?trackingStatus=delivered&breakBulkMilestone=${data}`
                Request.post({
                    url: ApiURLs.shipment.updateMilesTrackingStatus.replace(':shipmentId', id) + paramsUrl,
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errCallback,
                });
            },
            search: function (callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.search,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data
                });
            },
            unprocessedInvoice: function (callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.unprocessedInvoice,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data,
                    disableAbort: true
                })
            },
            getList: function (callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.list,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data,
                    disableAbort: true
                });
            },
            export: function (callback, errCallback, data) {
                DownloadReportsSocketService.downloadShipmentReport({
                    columns: [],
                    size: data.size,
                    shipmentExportPayload: data
                });
                callback(data);
            },
            addToList: function (data, callback) {
                Request.post({
                    url: ApiURLs.shipment.data,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: callback
                }, data);
            },
            getArchivedShipments: function (callback, errCallback, pagination, filters) {
                Request.get({
                    url: ApiURLs.shipment.archivedShipments,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: angular.element.extend({}, pagination || {}, filters || {})
                });
            },
            archiveShipments: function (ids, callback, errCallback, data) {
                Request.post({
                    url: ApiURLs.shipment.archivedShipment,
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errCallback
                }, ids);
            },
            changeStatusShipments: function (ids, callback, errCallback) {
                Request.post({
                    url: ApiURLs.shipment.changeTrackingStatus,
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errCallback
                }, ids);
            },
            getShipmentDetails: function (id, callback) {
                Request.get({
                    url: ApiURLs.shipment.byId + id,
                    successCallback: callback,
                    errorCallback: callback
                });
            },
            getNonManifested: function (callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.list,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: angular.extend({ manifested: false, bookingStatus: 'inprogress' }, data)
                });
            },
            getNonManifestedByCarrier: function (callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.getNonManifestedByCarrier,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data
                });
            },
            getTracking: function (id, callback, errCallback) {
                var url = ApiURLs.shipment.tracking.replace(/\{\{id\}\}/i, id);
                Request.get({
                    url: url,
                    successCallback: callback,
                    errorCallback: errCallback
                });
            },
            getTrackingLocation: function (trackingId, successCallback, errorCallback) {
                var url = ApiURLs.shipment.trackingCoordinates + trackingId;
                Request.get({
                    url: url,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            getStatistics: function (params, successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.shipment.statistics,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: params
                });
            },
            getNonManifestedStatistics: function (params, successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.shipment.nonManifestedStatics,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: params
                });
            },
            getStatisticsDifot: function (params, successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.shipment.statisticsDifot,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: params
                });
            },
            exportCSV: function (fileName, columns, params, requestData, successCallback, errorCallback) {
                var cols = {};
                if (columns !== undefined && columns.length > 0) {
                    cols = { columns: columns };
                }

                DownloadReportsSocketService.downloadShipmentReport({
                    shipmentExportPayload: requestData
                });
                successCallback();
            },
            exportByIds: function (fileName, columns, params, requestData, successCallback, errorCallback) {
                let cols = {};
                if (columns !== undefined && columns.length > 0) {
                    cols = { columns: columns }
                }

                DownloadReportsSocketService.downloadShipmentReportByIds({
                    shipmentIds: requestData,
                    columns
                });
                successCallback();

            },
            printLabels: function (options, successCallback, errorCallback) {
                Request.getFile({
                    // fileName: options.fileName,
                    fileType: 'application/pdf',
                    url: ApiURLs.shipment.label + options.shipmentIds + '/label',
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    responseType: 'arraybuffer'
                }, options.shipmentIds);
            },
            printConsignmentNote: function (options, successCallback, errorCallback) {
                Request.getFile({
                    method: 'PUT',
                    fileName: options.fileName,
                    fileType: 'application/pdf',
                    url: ApiURLs.shipment.consignmentNote,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                }, options.shipmentIds);
            },
            getDifotSummary: function (successCallback, errorCallback, pagination, filters) {
                Request.get({
                    url: ApiURLs.shipment.difotSummary,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(pagination || {}, filters || {})
                });
            },
            getAccountBySpend: function (successCallback, errorCallback, pagination, filters) {
                Request.get({
                    url: ApiURLs.shipment.accountBySpend,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(pagination || {}, filters || {})
                });
            },
            exportAccountBySpend: function (successCallback, errorCallback, filters) {
                Request.getFile({
                    url: ApiURLs.shipment.accountBySpendExport,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(filters || {})
                });
            },
            getOfficeBySpend: function (successCallback, errorCallback, pagination, filters) {
                Request.get({
                    url: ApiURLs.shipment.officeBySpend,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(pagination || {}, filters || {})
                });
            },
            getCarrierBySpend: function (successCallback, errorCallback, pagination, filters) {
                Request.get({
                    url: ApiURLs.shipment.carrierBySpend,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(pagination || {}, filters || {})
                });
            },
            exportCarrierBySpend: function (successCallback, errorCallback, filters) {
                Request.getFile({
                    url: ApiURLs.shipment.carrierBySpendExport,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: angular.element.extend(filters || {})
                });
            },
            customsDoc: function (listShipmentId, successCallback, errorCallback) {
                var d = new Date().getMilliseconds();
                var fileName = 'commercial-invoice-' + d;
                Request.downloadFile({
                    fileName: fileName,
                    fileType: 'application/pdf',
                    data: listShipmentId,
                    url: ApiURLs.shipment.customsDoc,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    responseType: 'arraybuffer'
                });
            },
            requestPod: function (id, successCallback, errorCallback) {
                Request.downloadFile({
                    fileName: 'proof-of-delivery-' + id,
                    method: 'GET',
                    url: ApiURLs.shipment.getPod.replace('{{id}}', id),
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    fileType: 'image/png',
                    responseType: 'arraybuffer'
                });
            },
            getShipmentCostFormatted: function (shipment) {
                let fixedAmt = '0';
                let minAmt, maxAmt, costFormatted, taxFormatted, dutiesFormatted;
                if (angular.getObjVal(shipment, 'timeBasedRateDetail.actualAmountUpdated') || !shipment.timeBasedRateDetail) {
                    fixedAmt = $filter('bbaCurrency')(shipment.amount, shipment.currency);
                    costFormatted = $filter('bbaCurrency')(angular.getObjVal(shipment, 'shippingCost.cost'), shipment.currency);
                    taxFormatted = $filter('bbaCurrency')(angular.getObjVal(shipment, 'shippingCost.vat'), shipment.currency);
                    dutiesFormatted = $filter('bbaCurrency')(angular.getObjVal(shipment, 'shippingCost.duties'), shipment.currency);
                }
                else if (shipment.timeBasedRateDetail) {
                    fixedAmt = `${$filter('bbaCurrency')(shipment.timeBasedRateDetail.hourlyRate, shipment.currency)}`;
                    costFormatted = fixedAmt + ' plus tax';
                    taxFormatted = 'Tax depends on the final amount';
                    dutiesFormatted = 'Duties depends on the final amount';
                }
                return {
                    amountFormatted: fixedAmt,
                    costFormatted: costFormatted,
                    taxFormatted: taxFormatted,
                    dutiesFormatted: dutiesFormatted
                }
            },
            getShipmentCostFormattedForFinalAndQuoted(data) {
                let fixedAmt = '0';
                let minAmt, maxAmt, costFormatted, taxFormatted, dutiesFormatted;

                if (angular.getObjVal(data, 'actualAmountUpdated') || !data.timeBasedRateDetail) {
                    fixedAmt = $filter('bbaCurrency')(data.amount, data.currency);
                    costFormatted = $filter('bbaCurrency')(angular.getObjVal(data, 'cost'), data.currency);
                    taxFormatted = $filter('bbaCurrency')(angular.getObjVal(data, 'vat'), data.currency);
                    dutiesFormatted = $filter('bbaCurrency')(angular.getObjVal(data, 'duties'), data.currency);
                }
                else if (data.timeBasedRateDetail) {
                    fixedAmt = `${$filter('bbaCurrency')(data.timeBasedRateDetail.hourlyRate, data.currency)} / hr`;
                    costFormatted = fixedAmt + ' plus tax';
                    taxFormatted = 'Tax depends on the final amount';
                    dutiesFormatted = 'Duties depends on the final amount';
                }

                return {
                    amountFormatted: fixedAmt,
                    costFormatted: costFormatted,
                    taxFormatted: taxFormatted,
                    dutiesFormatted: dutiesFormatted
                }
            },
            getConsolidationDetails: function (callback, errCallback, id) {
                Request.get({
                    url: ApiURLs.shipment.consolidationDetails.replace('{{id}}', id),
                    successCallback: callback,
                    errorCallback: errCallback,
                    disableAbort: true
                });
            },
            downloadPOD: function (shipmentId, successCallback, errorCallback) {
                Request.downloadFile({
                    fileName: 'proof-of-delivery-' + shipmentId,
                    method: 'GET',
                    url: ApiURLs.shipment.downloadPOD.replace('{{shipmentId}}', shipmentId),
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    fileType: 'application/pdf',
                    responseType: 'arraybuffer'
                });
            },
            updateTracking: function (shipmentId, trackingNumber, trackingStatus, successCallback, errorCallback) {
                Request.post({
                    method: 'PUT',
                    url: `${ApiURLs.shipment.updateTracking.replace(':shipmentId', shipmentId)}?trackingNumber=${trackingNumber}&trackingStatus=${trackingStatus}`,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            updateShipment: function (successCallback, errorCallback, shipmentId, payload) {
                Request.post({
                    method: 'PUT',
                    url: `${ApiURLs.shipment.shipmentDetails.replace(':shipmentId', shipmentId)}`,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                }, payload);
            },
            updateCarrierOrderId: function (successCallback, errorCallback, shipmentId, carrierOrderId) {
                Request.post({
                    method: 'PATCH',
                    url: `${ApiURLs.shipment.updateCarrierOrderId.replace(':shipmentId', shipmentId).replace(':carrierOrderId', carrierOrderId)}?reseller_id=75`,
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            downloadReceipt: function (successCallback, errorCallback, shipmentId) {
                const httpParams = {
                    url: ApiURLs.shipment.receipt.replace(':shipmentId', shipmentId),
                    method: 'GET',
                    transformResponse: [function (data) {
                        return data;
                    }]
                }
                $http(httpParams).success(function (data) {
                    window.open(data);
                    successCallback();
                }).error(function (response) {
                    errorCallback();
                });
            },
            requestShipmentDocs: function (id, successCallback, errorCallback) {
                Request.downloadFile({
                    fileName: 'documents' + id,
                    method: 'GET',
                    headers: { 'Content-Type': 'application/zip', Accept: 'application/zip' },
                    url: ApiURLs.shipment.downloadDocs.replace(':shipmentId', id),
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    fileType: 'application/zip',
                    responseType: 'arraybuffer'
                });
            },
            requestMultipleShipmentDocs: (ids, successCallback, errorCallback) => {
                successCallback();
            },
            deleteShipment: function (successCallback, errorCallback, shipmentId) {
                Request.post({
                    method: 'DELETE',
                    url: ApiURLs.shipment.deleteShipment.replace(':id', shipmentId),
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            },
            getConsolidatedShipments: function (successCallback, errorCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.consolidatedShipments,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: data,
                    disableAbort: true
                });
            },
            getBreakBulkShipments: function(successCallback, errorCallback, data) {
               Request.get({
                    url: ApiURLs.shipment.breakBulkShipments,
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    data: data,
                    disableAbort: true
               })
            }
        }
    });



// WEBPACK FOOTER //
// ./js/services/shipment.js